import { auth } from '@/lib';
import { useRunOnce } from '@nosinovacao/nosid-mfe-common';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/silent-token-renew')({
  component: RouteComponent,
  staticData: {
    anonymous: true,
  },
});

async function onSilentRenew() {
  await auth.processSilentRedirect();
}

function RouteComponent() {
  useRunOnce(() => {
    onSilentRenew();
  });
  return <></>;
}
